import {
  Autocomplete,
  FormLabel,
  FormHelperText,
  TextField,
  Typography,
  FormControlLabel,
  Box,
  Button,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import Select from "@mui/material/Select";
import "../../style/css/eventForm.css";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import Spinner from "../../Component/spinner/spinner";
import { ProfessionalEngagement, NatureOfWork, PrimarilyTeachingForTeacher, CurrentlyTeaching, TeachersExperience, TeachersQualification, ProfessionalDevelopment, InterdisciplinaryAreas, EnglishLanguageTeaching, Linguistics, LiteraryStudies, OTHER_PRIMARILY_TEACHING, EligibilityExaminations, Salutation, TypeOfInstitution } from '../../constant/constant'
import { Country, State } from 'country-state-city';
import { useLazyGetMemberDetailsByIdQuery, useUpdateMemberMutation } from '../../app/services/memberServices'
import { selectCurrentScope } from "../../app/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { setMemberDetails } from '../../app/features/memberSlice'
import { useParams, useNavigate } from "react-router-dom";

function TeachersProfile() {
  const [showEligibilityOtherInput, setShowEligibilityOtherInput] = useState(false);
  const [showEducationalOtherInput, setShowEducationalOtherInput] = useState(false);
  const [showProfessionOtherInput, setShowProfessionOtherInput] = useState(false);
  const [showLiteraryOtherInput, setShowLiteraryOtherInput] = useState(false);
  const [showLinguisticsOtherInput, setShowLinguisticsOtherInput] = useState(false);
  const [showELTOtherInput, setShowELTOtherInput] = useState(false);
  const [showInterOtherInput, setShowInterOtherInput] = useState(false);
  const [showPrimarilyOtherInput, setShowPrimarilyOtherInput] = useState(false);
  const navigate = useNavigate()
  const memberScope = useSelector(selectCurrentScope);

  //Teacher Contact Details
  /* ========================= */
  const [loading, setLoading] = useState(false);
  // const userId = useSelector(selectUserId);
  const [gettMemberDetailsByIdQuery] = useLazyGetMemberDetailsByIdQuery();
  const [updateMember] = useUpdateMemberMutation();
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [getStudentDetails, setGetStudentDetails] = useState()
  const dispatch = useDispatch()
  const { key } = useParams();
  const { id } = useParams()

  // useForm hook for form data handling
  const {
    control: controlContact,
    register: registerContact,
    handleSubmit: handleSubmitContact,
    setValue: setValueContact,
    formState: { errors: errorsContact },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      address: "",
      city: "",
      pinCode: "",
      state: "",
      country: "",
      mobileNumber: '',
      whatsAppNumber: '',
      email: "",
      landlineNumber: '',
      contactInformation: "",
      role: "PORTAL_MEMBER",
    },
  });

  const countries = Country.getAllCountries();
  const states = selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];

  // Update states whenever selectedCountry changes
  useEffect(() => {
    if (selectedCountry) {
      const fetchedStates = State.getStatesOfCountry(selectedCountry);
      setSelectedState(fetchedStates);
      // If we have getStudentDetails, set the state based on it
      if (getStudentDetails?.state) {
        setValueContact("state", getStudentDetails.state);
        setSelectedState(getStudentDetails.state); // Set the selected state
      } else {
        setValueContact("state", ""); // Reset state if no state exists
      }
    }
  }, [selectedCountry, setValueContact, getStudentDetails]);

  useEffect(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        setGetStudentDetails(res?.data?.data)
      }
    })
  }, [gettMemberDetailsByIdQuery, id])

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      const countryName = getStudentDetails.country; // Example country name
      const countryData = countryName === 'IN' ? Country.getAllCountries().find(
        (c) => c.isoCode.toLowerCase() === countryName.toLowerCase()
      ) : Country.getAllCountries().find(
        (c) => c.name.toLowerCase() === countryName.toLowerCase()
      );
      setValueContact("address", getStudentDetails.address)
      setValueContact("city", getStudentDetails.city)
      setValueContact("pinCode", getStudentDetails.pinCode)
      // setValueContact("country", getStudentDetails.country)
      // setSelectedCountry(getStudentDetails.country);
      setValueContact("country", countryData?.isoCode)
      setSelectedCountry(countryData?.isoCode)
      setValueContact("mobileNumber", getStudentDetails.mobileNumber)
      setValueContact("whatsAppNumber", getStudentDetails.whatsAppNumber)
      setValueContact("email", getStudentDetails.email)
      setValueContact("landlineNumber", getStudentDetails.landlineNumber)
      setValueContact("contactInformation", getStudentDetails.contactInformation)
    }
  }, [getStudentDetails, setValueContact])

  //On submit for update
  const UpdateTeachersMemberContact = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'contactInformation' && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    if (data.contactInformation && data.contactInformation.length > 0) {
      data.contactInformation.forEach(item => {
        formData.append("contactInformation", item)
      })
    }
    else {
      formData.append("contactInformation", [])
    }
    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/teacher-member/${id}`)
        } else {
          navigate(`/admin/teacher-member/${id}`)
        }

        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }
  //Basic Teacher

  const {
    control: BasicContact,
    register: registerBasic,
    handleSubmit: handleSubmitBasic,
    setValue: setValueBasic,
    formState: { errors: errorsBasic },
    watch
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      fullName: '',
      dateOfBirth: '',
      salutation: '',
      gender: '',
      role: "PORTAL_MEMBER",
    },
  });

  useEffect(() => {
    if (getStudentDetails) {
      const fieldsToUpdate = {
        fullName: getStudentDetails.fullName,
        dateOfBirth: getStudentDetails.dateOfBirth,
        salutation: getStudentDetails.salutation,
        gender: getStudentDetails.gender,
      };

      // Update form fields in one loop
      Object.entries(fieldsToUpdate).forEach(([key, value]) => {
        setValueBasic(key, value);
      });

      // Handle country separately if needed elsewher
    }
  }, [getStudentDetails, setValueBasic]);
  const UpdateTeachersMemberBasic = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/teacher-member/${id}`)
        } else {
          navigate(`/admin/teacher-member/${id}`)
        }

        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }
  //Teacher Academic Profile Links
  /* ========================= */

  // useForm hook for form data handling
  const {
    control: controlAcademic,
    register: registerAcademic,
    handleSubmit: handleSubmitAcademic,
    setValue: setValueAcademic,
    formState: { errors: errorsAcademic },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      institutionWebsite: "",
      scholarProfile: "",
      vidwanID: "",
      scopusProfileLink: "",
      ORICID: "",
      linkedInProfile: "",
      blog: "",
      youtubeChannel: '',
      shareInformation: '0',
      role: "PORTAL_MEMBER",
    },
  });

  useEffect(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        setGetStudentDetails(res?.data?.data)
      }
    })
  }, [gettMemberDetailsByIdQuery, id])

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueAcademic("institutionWebsite", getStudentDetails.institutionWebsite)
      setValueAcademic("scholarProfile", getStudentDetails.scholarProfile)
      setValueAcademic("vidwanID", getStudentDetails.vidwanID)
      setValueAcademic("scopusProfileLink", getStudentDetails.scopusProfileLink)
      setValueAcademic("ORICID", getStudentDetails.ORICID)
      setValueAcademic("linkedInProfile", getStudentDetails.linkedInProfile)
      setValueAcademic("blog", getStudentDetails.blog)
      setValueAcademic("youtubeChannel", getStudentDetails.youtubeChannel)
      setValueAcademic("shareInformation", getStudentDetails.shareInformation)
    }
  }, [getStudentDetails, setValueAcademic])

  //On submit for update
  const UpdateTeachersMemberAcademic = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/teacher-member/${id}`)
        } else {
          navigate(`/admin/teacher-member/${id}`)
        }
        if (res.data.status) {
          gettMemberDetailsByIdQuery(id).then((res) => {
            if (res?.data?.status) {
              dispatch(setMemberDetails(res?.data?.data))
            }
          })
        }
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  //Teacher Professional Details
  /* ========================= */

  const [otherEligibility, setOtherEligibility] = useState('');
  const [otherEducational, setOtherEducational] = useState('');
  const [otherPrimarily, setOtherPrimarily] = useState('');

  // useForm hook for form data handling
  const {
    control: controlEducation,
    register: registerEducation,
    handleSubmit: handleSubmitEducation,
    setValue: setValueEducation,
    clearErrors,
    formState: { errors: errorsEducation },
    trigger
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      educationalQualification: "",
      eligibilityExamination: "",
      teacherExperience: "",
      teaching: "",
      currentDesignation: "",
      institution: "",
      lastDesignation: "",
      institutionWorkedLast: "",
      primarilyTeachingLevel: "",
      otherprimarilyTeachingLevel: "",
      natureWork: "",
      phdResearchSupervisor: "",
      nameResearchSupervisor: "",
      role: "PORTAL_MEMBER",
    },
  });



  const eligibilityOptions = useMemo(() => EligibilityExaminations.map(exam => exam.name), []);
  const educationalOptions = useMemo(() => TeachersQualification.map(exam => exam.name), []);

  // Memoizing the options arrays
  const memoizedEducationalOptions = useMemo(() => educationalOptions, [educationalOptions]);
  const memoizedEligibilityOptions = useMemo(() => eligibilityOptions, [eligibilityOptions]);

  //Get by id member details
  const getMemberDetails = useCallback(
    () => {
      gettMemberDetailsByIdQuery(id).then((res) => {
        if (res?.data?.status) {
          const studentDetails = res?.data?.data;
          setGetStudentDetails(studentDetails);

          const educationalExams = studentDetails?.educationalQualification || [];
          const othereducationalText = educationalExams.find(item => !memoizedEducationalOptions.includes(item));
          setOtherEducational(othereducationalText || '');
          setShowEducationalOtherInput(!!othereducationalText);

          setValueEducation('otherEducational', othereducationalText);

          const eligibilityExams = studentDetails?.eligibilityExamination || [];
          const otherText = eligibilityExams.find(item => !memoizedEligibilityOptions.includes(item));
          setOtherEligibility(otherText || '');
          setShowEligibilityOtherInput(!!otherText);

          setValueEducation('otherEligibility', otherText);

          const primarilyTeachingLevel = studentDetails?.primarilyTeachingLevel;
          const isOtherPrimarily = primarilyTeachingLevel === OTHER_PRIMARILY_TEACHING ? true : false;
          setOtherPrimarily(isOtherPrimarily ? studentDetails?.otherprimarilyTeachingLevel : '');
          setShowPrimarilyOtherInput(isOtherPrimarily);
        }
      });
    }, [gettMemberDetailsByIdQuery, id, memoizedEducationalOptions, memoizedEligibilityOptions, setValueEducation])

  //Get all member details
  useEffect(() => {
    getMemberDetails()
  }, [getMemberDetails]);

  const handleOtherEligibilityChange = (e) => {
    const inputValue = e.target.value;
    setOtherEligibility(inputValue);
    if (inputValue && !eligibilityOptions.includes(inputValue)) {
      setShowEligibilityOtherInput(true);
    }
  };

  const handleOtherEducationalChange = (e) => {
    const inputValue = e.target.value;
    setOtherEducational(inputValue);
    if (inputValue && !educationalOptions.includes(inputValue)) {
      setShowEducationalOtherInput(true);
    }
  };

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueEducation("educationalQualification", getStudentDetails.educationalQualification)
      setValueEducation("eligibilityExamination", getStudentDetails.eligibilityExamination)
      setValueEducation("teacherExperience", getStudentDetails.teacherExperience)
      setValueEducation("teaching", getStudentDetails.teaching)
      setValueEducation("currentDesignation", getStudentDetails.currentDesignation)
      setValueEducation("institution", getStudentDetails.institution)
      setValueEducation("lastDesignation", getStudentDetails.lastDesignation)
      setValueEducation("institutionWorkedLast", getStudentDetails.institutionWorkedLast)
      setValueEducation("primarilyTeachingLevel", getStudentDetails.primarilyTeachingLevel)
      setValueEducation("otherprimarilyTeachingLevel", getStudentDetails.otherprimarilyTeachingLevel)
      setValueEducation("natureWork", getStudentDetails.natureWork)
      setValueEducation("phdResearchSupervisor", getStudentDetails.phdResearchSupervisor)
      setValueEducation("nameResearchSupervisor", getStudentDetails.nameResearchSupervisor)
    }
  }, [getStudentDetails, setValueEducation])

  //On submit for update
  const UpdateTeachersMemberEducation = async (data, id) => {
    setLoading(true)
    // Trigger form validation first
    const isValid = await trigger(); // This triggers validation for all fields

    if (!isValid) {
      setLoading(false);
      return; // Stop the form submission if validation fails
    }
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'educationalQualification' && key !== 'nameResearchSupervisor' && key !== 'eligibilityExamination' && key !== 'otherprimarilyTeachingLevel' && key !== 'primarilyTeachingLevel' && key !== 'otherEligibility' && key !== 'otherEducational' && key !== 'otherPrimarily' && value !== undefined && value !== null) {
        formData.append(key, value);
      }
      if (key === 'nameResearchSupervisor') {
        if (isPhd.toString() === '1') {
          formData.append(key, value);
        }
        else {
          formData.append(key, '');
        }
      }
    });

    // Handle educational qualification updates
    let updatedEducationalExams = [...data.educationalQualification];
    const otherEducationalInputIndex = updatedEducationalExams.findIndex(value => value === 'Other')
    const otherText = updatedEducationalExams.filter(v => !memoizedEducationalOptions.find(d => d === v)).filter(v => v !== otherEducational)

    if (updatedEducationalExams.length > 0) {
      updatedEducationalExams.forEach(item => {
        if (item.trim() !== '' && !otherText.includes(item)) {
          formData.append("educationalQualification", item);
        }
      });
    }
    else {
      formData.append("educationalQualification", []);
    }
    if (otherEducationalInputIndex !== -1 && otherEducational && !updatedEducationalExams.includes(otherEducational)) {
      formData.append("educationalQualification", otherEducational); // Ensure this is appended correctly
    }
    // Handle eligibility examination updates
    let updatedEligibilityExams = [...data.eligibilityExamination];
    const otherInputIndex = updatedEligibilityExams.findIndex(value => value === 'Other')
    const otherEligibilityText = updatedEligibilityExams.filter(v => !memoizedEligibilityOptions.find(d => d === v)).filter(v => v !== otherEligibility)

    if (updatedEligibilityExams.length > 0) {
      updatedEligibilityExams.forEach(item => {
        if (item.trim() !== '' && !otherEligibilityText.includes(item)) {
          formData.append("eligibilityExamination", item);
        }
      });
    }
    else {
      formData.append("eligibilityExamination", []);
    }
    if (otherInputIndex !== -1 && otherEligibility && !updatedEligibilityExams.includes(otherEligibility)) {
      formData.append("eligibilityExamination", otherEligibility); // Ensure this is appended correctly
    }
    // Handle primarilyTeachingLevel and otherprimarilyTeachingLevel
    const { primarilyTeachingLevel } = data;
    formData.append("primarilyTeachingLevel", primarilyTeachingLevel);
    if (showPrimarilyOtherInput && otherPrimarily) {
      formData.append("otherprimarilyTeachingLevel", otherPrimarily);
    } else {
      formData.append("otherprimarilyTeachingLevel", "");
    }

    // Send data to the backend
    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/teacher-member/${id}`)
        } else {
          navigate(`/admin/teacher-member/${id}`)
        }
        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  //Teacher Professional Development
  /* ========================= */

  const [otherProfession, setOtherProfession] = useState('');
  const [otherLit, setOtherLit] = useState('');
  const [otherLing, setOtherLing] = useState('');
  const [otherELT, setOtherELT] = useState('');
  const [otherInter, setOtherInter] = useState('');

  // useForm hook for form data handling
  const {
    control: controlProfession,
    register: registerProfession,
    handleSubmit: handleSubmitProfession,
    setValue: setValueProfession,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      teacherAssociation: 0,
      associationName: "",
      professionalDevelopment: "",
      expertiseLiteraryStudies: "",
      expertiseLinguistics: "",
      expertiseELT: "",
      expertiseInterdisciplinaryAreas: "",
      areaOfExpertise: 0,
      professionalEngagement: "",
      role: "PORTAL_MEMBER",
    },
  });

  const professionOptions = useMemo(() => ProfessionalDevelopment.map(exam => exam.name), []);
  const litOptions = useMemo(() => LiteraryStudies.map(exam => exam.name), []);
  const lingOptions = useMemo(() => Linguistics.map(exam => exam.name), []);
  const ELTOptions = useMemo(() => EnglishLanguageTeaching.map(exam => exam.name), []);
  const interOptions = useMemo(() => InterdisciplinaryAreas.map(exam => exam.name), []);

  // Memoizing the options arrays
  const memoizedProfessionOptions = useMemo(() => professionOptions, [professionOptions]);
  const memoizedLitOptions = useMemo(() => litOptions, [litOptions]);
  const memoizedLingOptions = useMemo(() => lingOptions, [lingOptions]);
  const memoizedELTOptions = useMemo(() => ELTOptions, [ELTOptions]);
  const memoizedInterOptions = useMemo(() => interOptions, [interOptions]);

  const getMemberDetailsById = useCallback(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        const studentDetails = res?.data?.data;
        setGetStudentDetails(studentDetails);

        const professionExams = studentDetails?.professionalDevelopment || [];
        const otherText = professionExams.find(item => !memoizedProfessionOptions.includes(item));
        setOtherProfession(otherText || '');
        setShowProfessionOtherInput(!!otherText);

        setValueProfession('otherProfession', otherText);

        const LitExams = studentDetails?.expertiseLiteraryStudies || [];
        const otherLitText = LitExams.find(item => !memoizedLitOptions.includes(item));
        setOtherLit(otherLitText || '');
        setShowLiteraryOtherInput(!!otherLitText);

        setValueProfession('otherLit', otherLitText);

        const LingExams = studentDetails?.expertiseLinguistics || [];
        const otherLingText = LingExams.find(item => !memoizedLingOptions.includes(item));
        setOtherLing(otherLingText || '');
        setShowLinguisticsOtherInput(!!otherLingText);

        setValueProfession('otherLing', otherLingText);

        const ELTExams = studentDetails?.expertiseELT || [];
        const otherELTText = ELTExams.find(item => !memoizedELTOptions.includes(item));
        setOtherELT(otherELTText || '');
        setShowELTOtherInput(!!otherELTText);

        setValueProfession('otherELT', otherELTText);

        const interExams = studentDetails?.expertiseInterdisciplinaryAreas || [];
        const otherInterText = interExams.find(item => !memoizedInterOptions.includes(item));
        setOtherInter(otherInterText || '');
        setShowInterOtherInput(!!otherInterText);

        setValueProfession('otherInter', otherInterText);
      }
    });
  }, [gettMemberDetailsByIdQuery, memoizedProfessionOptions, memoizedLitOptions, memoizedLingOptions, memoizedELTOptions, memoizedInterOptions, setValueProfession, id])

  //Get member details by id
  useEffect(() => {
    getMemberDetailsById()
  }, [getMemberDetailsById]);

  const handleOtherProfessionChange = (e) => {
    const inputValue = e.target.value;
    setOtherProfession(inputValue);
    if (inputValue && !professionOptions.includes(inputValue)) {
      setShowProfessionOtherInput(true);
    }
  };

  const handleOtherLitChange = (e) => {
    const inputValue = e.target.value;
    setOtherLit(inputValue);
    if (inputValue && !litOptions.includes(inputValue)) {
      setShowLiteraryOtherInput(true);
    }
  };

  const handleOtherLingChange = (e) => {
    const inputValue = e.target.value;
    setOtherLing(inputValue);
    if (inputValue && !lingOptions.includes(inputValue)) {
      setShowLinguisticsOtherInput(true);
    }
  };

  const handleOtherELTChange = (e) => {
    const inputValue = e.target.value;
    setOtherELT(inputValue);
    if (inputValue && !ELTOptions.includes(inputValue)) {
      setShowELTOtherInput(true);
    }
  };

  const handleOtherInterChange = (e) => {
    const inputValue = e.target.value;
    setOtherInter(inputValue);
    if (inputValue && !interOptions.includes(inputValue)) {
      setShowInterOtherInput(true);
    }
  };

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueProfession("teacherAssociation", getStudentDetails.teacherAssociation)
      setValueProfession("associationName", getStudentDetails.associationName)
      setValueProfession("professionalDevelopment", getStudentDetails.professionalDevelopment)
      setValueProfession("expertiseLiteraryStudies", getStudentDetails.expertiseLiteraryStudies)
      setValueProfession("expertiseLinguistics", getStudentDetails.expertiseLinguistics)
      setValueProfession("expertiseELT", getStudentDetails.expertiseELT)
      setValueProfession("expertiseInterdisciplinaryAreas", getStudentDetails.expertiseInterdisciplinaryAreas)
      setValueProfession("areaOfExpertise", getStudentDetails.areaOfExpertise)
      setValueProfession("professionalEngagement", getStudentDetails.professionalEngagement)
    }
  }, [getStudentDetails, setValueProfession])

  //On submit for update
  const UpdateTeachersMemberProfession = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'professionalDevelopment' && key !== 'expertiseLiteraryStudies' && key !== 'expertiseLinguistics' && key !== 'expertiseELT' && key !== 'expertiseInterdisciplinaryAreas' && key !== 'otherProfession' && key !== 'otherLit' && key !== 'otherLing' && key !== 'otherELT' && key !== 'otherInter' && key !== 'professionalEngagement' && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    let updatedProfessionExams = [...data.professionalDevelopment].filter(item => item.trim() !== '');
    const otherInputIndex = updatedProfessionExams.findIndex(value => value === 'Other')
    const otherProfessionText = updatedProfessionExams.filter(v => !memoizedProfessionOptions.find(d => d === v)).filter(v => v !== otherProfession)
    if (otherInputIndex !== -1 && otherProfession && !updatedProfessionExams.includes(otherProfession)) {
      formData.append("professionalDevelopment", otherProfession); // Ensure this is appended correctly
    }
    if (updatedProfessionExams.length > 0) {
      updatedProfessionExams.forEach(item => {
        if (!otherProfessionText.includes(item)) {
          formData.append("professionalDevelopment", item);
        }
      });
    }
    else {
      formData.append("professionalDevelopment", []);
    }

    let updatedLitExams = [...data.expertiseLiteraryStudies].filter(item => item.trim() !== '');
    const otherInputLitIndex = updatedLitExams.findIndex(value => value === 'Other')
    const otherLitText = updatedLitExams.filter(v => !memoizedLitOptions.find(d => d === v)).filter(v => v !== otherLit)
    if (otherInputLitIndex !== -1 && otherLit && !updatedLitExams.includes(otherLit)) {
      formData.append("expertiseLiteraryStudies", otherLit); // Ensure this is appended correctly
    }
    if (updatedLitExams.length > 0) {
      updatedLitExams.forEach(item => {
        if (!otherLitText.includes(item)) {
          formData.append("expertiseLiteraryStudies", item);
        }
      });
    }
    else {
      formData.append("expertiseLiteraryStudies", []);
    }

    let updatedLingExams = [...data.expertiseLinguistics].filter(item => item.trim() !== '');
    const otherInputLingIndex = updatedLingExams.findIndex(value => value === 'Other')
    const otherLingText = updatedLingExams.filter(v => !memoizedLingOptions.find(d => d === v)).filter(v => v !== otherLing)
    if (otherInputLingIndex !== -1 && otherLing && !updatedLingExams.includes(otherLing)) {
      formData.append("expertiseLinguistics", otherLing); // Ensure this is appended correctly
    }

    if (updatedLingExams.length > 0) {
      updatedLingExams.forEach(item => {
        if (!otherLingText.includes(item))
          formData.append("expertiseLinguistics", item);
      });
    }
    else {
      formData.append("expertiseLinguistics", []);
    }

    let updatedELTExams = [...data.expertiseELT].filter(item => item.trim() !== '');
    const otherInputELTIndex = updatedELTExams.findIndex(value => value === 'Other')
    const otherELTText = updatedELTExams.filter(v => !memoizedELTOptions.find(d => d === v)).filter(v => v !== otherELT)
    if (otherInputELTIndex !== -1 && otherELT && !updatedELTExams.includes(otherELT)) {
      formData.append("expertiseELT", otherELT); // Ensure this is appended correctly
    }
    if (updatedLitExams.length > 0) {
      updatedELTExams.forEach(item => {
        if (!otherELTText.includes(item))
          formData.append("expertiseELT", item);
      });
    }
    else {
      formData.append("expertiseELT", []);
    }

    let updatedInterExams = [...data.expertiseInterdisciplinaryAreas].filter(item => item.trim() !== '');
    const otherInputInterIndex = updatedInterExams.findIndex(value => value === 'Other')
    const otherInterText = updatedProfessionExams.filter(v => !memoizedProfessionOptions.find(d => d === v)).filter(v => v !== otherInter)
    if (otherInputInterIndex !== -1 && otherInter && !updatedProfessionExams.includes(otherInter)) {
      formData.append("expertiseInterdisciplinaryAreas", otherInter); // Ensure this is appended correctly
    }
    if (updatedInterExams.length > 0) {
      updatedInterExams.forEach(item => {
        if (!otherInterText.includes(item))
          formData.append("expertiseInterdisciplinaryAreas", item);
      });
    }
    else {
      formData.append("expertiseInterdisciplinaryAreas", []);
    }

    if (data.professionalEngagement && data.professionalEngagement.length > 0) {
      data.professionalEngagement.forEach(item => {
        formData.append("professionalEngagement", item);
      });
    }
    else {
      formData.append("professionalEngagement", []);
    }

    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/teacher-member/${id}`)
        } else {
          navigate(`/admin/teacher-member/${id}`)
        }
        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  // Watch the teaching field value
  const isTeaching = useWatch({
    control: controlEducation,
    name: 'teaching',
    defaultValue: '',
  });

  // Watch the phdResearchSupervisor field value
  const isPhd = useWatch({
    control: controlEducation,
    name: 'phdResearchSupervisor',
    defaultValue: '',
  });

  // Watch the teacherAssociation field value
  const isTeachersAsso = useWatch({
    control: controlProfession,
    name: 'teacherAssociation',
    defaultValue: '',
  });

  return (
    < >

      {/* basic Details*/}
      {key === "basic" && (
        <Box>
          <div className="pt-1 pb-3">
            <div className="p-0">
              <div className="Architects-header d-flex align-items-center justify-content-center">
                <h2 className="title-font text-center">Basic Details</h2>
              </div>
            </div>
          </div>
          <div className="p-md-5 p-3 overallPadding">
            <div className="text-end mb-3">
              <Button
                onClick={() => window.history.back()}
                variant="contained"
                className="menus-color"
              >
                Back
              </Button>
            </div>

            {loading ? (
              <Spinner />
            ) : (
              <>
                <form
                  className="mt-2"
                  onSubmit={handleSubmitBasic((data) => UpdateTeachersMemberBasic(data, id))}
                >
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12}></Grid>

                    <Grid item lg={4} md={6} xs={12}>
                      <Controller
                        control={BasicContact}
                        rules={{ required: "Please select an option" }}
                        name="salutation"
                        render={({ field, fieldState }) => (
                          <FormControl fullWidth>
                            <InputLabel className="text-dark" id="Salutation">
                              Salutation<span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <Select
                              className="bg-white"
                              labelId="Salutation"
                              id="Salutation"
                              label={
                                <Typography className="text-dark">
                                  Salutation
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                              }
                              value={field.value === "" ? "" : field.value}
                              variant="outlined"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={!!fieldState.error}
                            >
                              {Salutation.map((data) => (
                                <MenuItem key={data.Name} value={data.id}>
                                  {data.Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={
                          <Typography className="text-dark">
                            Your Full Name<span style={{ color: "red" }}>*</span>
                          </Typography>
                        }

                        {...registerBasic("fullName", {
                          required: "Please enter a full name",
                          minLength: {
                            value: 3,
                            message: "Please enter a valid name",
                          },
                        })}
                        error={!!errorsBasic?.fullName}
                        helperText={errorsBasic?.fullName?.message}
                        placeholder="Your Full Name"
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={
                          <Typography className="text-dark">
                            Your Date of Birth
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        variant="outlined"
                        type="date"
                        value={
                          watch("dateOfBirth")
                            ? watch("dateOfBirth").split("T")[0]
                            : ""
                        }
                        {...registerBasic("dateOfBirth", {
                          required: "Please select your date of birth",
                          max: {
                            value: new Date().toISOString().split("T")[0],
                            message: "Future date is not allowed",
                          },
                        })}
                        error={!!errorsBasic?.dateOfBirth}
                        helperText={errorsBasic?.dateOfBirth?.message}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                      <FormControl component="fieldset" error={!!errorsBasic.gender}>
                        <FormLabel className="text-dark" component="legend">
                          Your Gender<span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <Controller
                          name="gender"
                          control={BasicContact}
                          defaultValue=""
                          rules={{ required: "Please select your gender" }}
                          render={({ field }) => (
                            <RadioGroup row {...field}>
                              <FormControlLabel
                                value="0"
                                control={<Radio />}
                                label="Male"
                              />
                              <FormControlLabel
                                value="1"
                                control={<Radio />}
                                label="Female"
                              />
                              <FormControlLabel
                                value="3"
                                control={<Radio />}
                                label="Transgender"
                              />
                            </RadioGroup>
                          )}
                        />
                        {errorsBasic.gender && (
                          <FormHelperText>{errorsBasic.gender.message}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>



                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              </>
            )}
          </div>

        </Box>
      )}
      {/* Teacher Contact Details */}
      <>
        {key === "contact" && (
          <Box>
            <div className="pt-1 pb-3">
              <div className="p-0">
                <div className="Architects-header d-flex align-items-center justify-content-center">
                  <h2 className="title-font text-center">Contact Details</h2>
                </div>
              </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <form
                  className="mt-2"
                  onSubmit={handleSubmitContact((data) => UpdateTeachersMemberContact(data, id))}
                >
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12}></Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Address <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("address", {
                          required: "Please Enter an Address", maxLength: {
                            value: 160,
                            message: 'Address must be less than or equal to 160 characters'
                          }
                        })}
                        error={!!errorsContact?.address}
                        helperText={errorsContact?.address?.message}
                        placeholder="Address"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Mobile Number <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("mobileNumber", {
                          required: "Please Enter a Mobile Number",
                          pattern: {
                            value: /^\d{10}$/,
                            message: "Mobile number must be 10 digits",
                          },
                        })}
                        error={!!errorsContact?.mobileNumber}
                        helperText={errorsContact?.mobileNumber?.message}
                        placeholder="Mobile Number"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">City/Town <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("city", { required: "Please Enter a City/Town" })}
                        error={!!errorsContact?.city}
                        helperText={errorsContact?.city?.message}
                        placeholder="City/Town"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">WhatsApp Number <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("whatsAppNumber", {
                          required: "Please Enter a WhatsApp Number",
                          pattern: {
                            value: /^\d{10}$/,
                            message: "Whatsapp number must be 10 digits",
                          },
                        })}
                        error={!!errorsContact?.whatsAppNumber}
                        helperText={errorsContact?.whatsAppNumber?.message}
                        placeholder="WhatsApp Number"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">PIN Code <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("pinCode", {
                          required: "Please Enter a PIN Code",
                          pattern: {
                            value: /^\d{6}$/,
                            message: "Pincode must be 6 digits",
                          },
                        })}
                        error={!!errorsContact?.pinCode}
                        helperText={errorsContact?.pinCode?.message}
                        placeholder="PIN Code"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Email Address <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("email", {
                          required: "Please Enter an Email",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Enter a valid email ID",
                          },
                        })}
                        error={!!errorsContact?.email}
                        helperText={errorsContact?.email?.message}
                        placeholder="Email Address"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsContact.state}>
                        <InputLabel>State <span style={{ color: "red" }}>*</span></InputLabel>
                        <Controller
                          name="state"
                          control={controlContact}
                          defaultValue=""
                          rules={{ required: selectedCountry ? "State is required" : false }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="state"
                              label={
                                <Typography className="text-dark">
                                  state
                                </Typography>
                              }
                              value={selectedState}
                              // disabled
                              onChange={(e) => {
                                setSelectedState(e.target.value);
                                field.onChange(e);
                              }}
                              variant="outlined"

                            >
                              {states.map((state) => (
                                <MenuItem key={state.isoCode} value={state.name}>
                                  {state.name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errorsContact.state && <FormHelperText>{errorsContact.state.message}</FormHelperText>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsContact.country}>
                        <InputLabel>Country <span style={{ color: "red" }}>*</span></InputLabel>
                        <Controller
                          name="country"
                          control={controlContact}
                          defaultValue=""
                          rules={{ required: "Country is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="Country"
                              label={
                                <Typography className="text-dark">
                                  Country
                                </Typography>
                              }
                              value={selectedCountry}
                              onChange={(e) => {
                                setSelectedCountry(e.target.value);
                                field.onChange(e);
                              }}
                              variant="outlined"

                            >
                              {countries.map((country) => (
                                <MenuItem key={country.isoCode} value={country.isoCode}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                          disabled
                        />
                        {errorsContact.country && <FormHelperText>{errorsContact.country.message}</FormHelperText>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ type: "number" }}
                        fullWidth
                        label={<Typography className="text-dark">Telephone Number </Typography>}
                        {...registerContact("landlineNumber")}
                        // error={!!errorsContact?.landlineNumber}
                        // helperText={errorsContact?.landlineNumber?.message}
                        placeholder="Telephone Number"
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={6} lg={4}>
                          <Controller
                            control={controlContact}
                            name="contactInformation"
                            render={({ field, fieldState }) => (
                              <Autocomplete
                                multiple
                                id="contactInformation"
                                fullWidth
                                options={ContactInformationVisibility}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoNames = selectedValues.map((value) => value?.name);
                                  field.onChange(contactInfoNames);
                                }}
                                value={
                                  field.value ?
                                    ContactInformationVisibility.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={!!fieldState?.error}
                                    helperText={fieldState?.error?.message}
                                    label={<Typography className="text-dark">Contact Information Visibility</Typography>}
                                    placeholder="Select Contact Information Visibility"
                                  />
                                )}
                              />
                            )}
                          />
                        </Grid> */}
                  </Grid>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>

          </Box>
        )}
      </>

      {/* Teacher Academic Profile Links */}
      <>
        {key === "academic" && (
          <>
            <Box>
              <div className='pt-1 pb-3'>
                <div className='p-0'>
                  <div className='Architects-header d-flex align-items-center justify-content-center'>
                    <h2 className='title-font text-center'>Academic Profile Links</h2>
                  </div>
                </div>
              </div>
            </Box>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <form className="mt-2" onSubmit={handleSubmitAcademic((data) => UpdateTeachersMemberAcademic(data, id))}>
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12}></Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Profile on your institutions’ website</Typography>}
                        {...registerAcademic("institutionWebsite", {
                          pattern: {
                            value: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*(\?[^\s#]*)?(#[^\s]*)?\/?$/,
                            message: "Please enter a valid profile URL",
                          }
                        })}
                        error={!!errorsAcademic?.institutionWebsite}
                        helperText={errorsAcademic?.institutionWebsite?.message}
                        placeholder="Institution Website"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Google Scholar Profile</Typography>}
                        {...registerAcademic("scholarProfile", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*(\?[^\s#]*)?(#[^\s]*)?\/?$/,
                            message: "Please enter a valid google scholar profile",
                          },
                        })}
                        error={!!errorsAcademic?.scholarProfile}
                        helperText={errorsAcademic?.scholarProfile?.message}
                        placeholder="Google Scholar Profile"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Vidwan ID</Typography>}
                        {...registerAcademic("vidwanID")}
                        error={!!errorsAcademic?.vidwanID}
                        helperText={errorsAcademic?.vidwanID?.message}
                        placeholder="Vidwan ID"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Scopus Profile Link</Typography>}
                        {...registerAcademic("scopusProfileLink", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*(\?[^\s#]*)?(#[^\s]*)?\/?$/,
                            message: "Please enter a valid scopus profile link",
                          },
                        })}
                        error={!!errorsAcademic?.scopusProfileLink}
                        helperText={errorsAcademic?.scopusProfileLink?.message}
                        placeholder="Scopus Profile Link"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your ORICID Id</Typography>}
                        {...registerAcademic("ORICID")}
                        error={!!errorsAcademic?.ORICID}
                        helperText={errorsAcademic?.ORICID?.message}
                        placeholder="ORICID Id"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your LinkedIn Profile</Typography>}
                        {...registerAcademic("linkedInProfile", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*(\?[^\s#]*)?(#[^\s]*)?\/?$/,
                            message: "Please enter a valid linkedin  profile",
                          },
                        })}
                        error={!!errorsAcademic?.linkedInProfile}
                        helperText={errorsAcademic?.linkedInProfile?.message}
                        placeholder="LinkedIn Profile"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Blog/Website</Typography>}
                        {...registerAcademic("blog", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*(\?[^\s#]*)?(#[^\s]*)?\/?$/,
                            message: "Please enter a valid blog/website",
                          },
                        })}
                        error={!!errorsAcademic?.blog}
                        helperText={errorsAcademic?.blog?.message}
                        placeholder="Blog/Website"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Youtube Channel</Typography>}
                        {...registerAcademic("youtubeChannel")}
                        error={!!errorsAcademic?.youtubeChannel}
                        helperText={errorsAcademic?.youtubeChannel?.message}
                        placeholder="Youtube Channel"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsAcademic.shareInformation}>
                        <FormLabel component="legend">Consent To Share Information</FormLabel>
                        <Controller
                          name="shareInformation"
                          control={controlAcademic}
                          defaultValue=""
                          render={({ field }) => (
                            <RadioGroup
                              {...field}
                              row
                              onChange={(e) => field.onChange(e.target.value)}
                            >
                              <FormControlLabel value="1" control={<Radio />} label="Yes" />
                              <FormControlLabel value="0" control={<Radio />} label="No" />
                            </RadioGroup>
                          )}
                        />
                        {errorsAcademic.shareInformation && (
                          <FormHelperText>{errorsAcademic.shareInformation.message}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>
          </>
        )}
      </>

      {/* Teacher Professional Details */}
      <>
        {key === "profession" && (
          <>
            <Box>
              <div className="pt-1 pb-3">
                <div className="p-0">
                  <div className="Architects-header d-flex align-items-center justify-content-center">
                    <h2 className="title-font text-center">Professional Details</h2>
                  </div>
                </div>
              </div>
            </Box>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <Box className="container-fluid" sx={{ width: "100%", marginTop: "0px", marginBottom: "50px" }}>
                  <form className="mt-2" onSubmit={handleSubmitEducation((data) => UpdateTeachersMemberEducation(data, id))}>
                    <Grid container rowSpacing={3} columnSpacing={2}>
                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="educationalQualification"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                limitTags={2}
                                id="educationalQualification"
                                fullWidth
                                options={TeachersQualification}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                  setShowEducationalOtherInput(isOtherSelected);
                                  if (isOtherSelected) {
                                    setValueEducation('otherEducational', ''); // Reset the value of otherEligibility
                                  }
                                  else {
                                    setValueEducation('otherEducational', '')
                                  }
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  Array.isArray(field.value) ?
                                    TeachersQualification.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      <Typography className="text-dark">
                                        Your Educational Qualification
                                      </Typography>
                                    }
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showEducationalOtherInput && (
                                <Controller
                                  name="otherEducational"
                                  control={controlEducation}
                                  rules={{
                                    required: 'Please specify your other educational qualification',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other educational qualification"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherEducationalChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="eligibilityExamination"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                id="eligibilityExamination"
                                fullWidth
                                limitTags={2}
                                options={EligibilityExaminations}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                  setShowEligibilityOtherInput(isOtherSelected);
                                  if (isOtherSelected) {
                                    setValueEducation('otherEligibility', ''); // Reset the value of otherEligibility
                                  }
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  Array.isArray(field.value) ?
                                    EligibilityExaminations.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      <Typography className="text-dark overflow-hidden text-nowrap" style={{ textOverflow: "ellipsis" }}>
                                        Have You Got Through Any Eligibility Examinations?
                                      </Typography>
                                    }
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showEligibilityOtherInput && (
                                <Controller
                                  name="otherEligibility"
                                  control={controlEducation}
                                  rules={{
                                    required: 'Please specify your other eligibility studies',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other eligibility studies"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherEligibilityChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="teacherExperience"

                          render={({ field, fieldState }) => (
                            <>
                              <FormControl fullWidth>
                                <InputLabel>
                                  <Typography className="text-dark">Teaching Experience (in years)</Typography>
                                </InputLabel>
                                <Select
                                  value={field.value || ""}
                                  labelId="Teaching Experience (in years)"
                                  label={
                                    <Typography className="text-dark">
                                      Teaching Experience (in years)
                                    </Typography>
                                  }
                                  margin="normal"
                                  onChange={(event) => field.onChange(event.target.value)}
                                  // displayEmpty
                                  variant="outlined"
                                >
                                  <MenuItem value="">
                                  </MenuItem>
                                  {TeachersExperience.map((option) => (
                                    <MenuItem key={option.id} value={option.name}>
                                      {option.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {fieldState?.error && (
                                  <FormHelperText error>
                                    {fieldState.error.message}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="teaching"
                          rules={{ required: "This field is required" }}
                          render={({ field, fieldState }) => (
                            <>
                              <FormControl fullWidth>
                                <InputLabel>
                                  <Typography className="text-dark">Are you currently teaching?{" "}<span style={{ color: "red" }}>*</span></Typography>
                                </InputLabel>
                                <Select
                                  label="Teaching Experience (in years)"
                                  value={field.value}
                                  onChange={(event) => {
                                    const selectedValue = event.target.value;
                                    field.onChange(selectedValue);
                                    setValueEducation('currentDesignation', '');
                                    if (selectedValue !== '1') {
                                      clearErrors('currentDesignation'); // Clear error if not "Yes"
                                    }
                                    setValueEducation('institution', '');
                                    if (selectedValue !== '1') {
                                      clearErrors('institution');
                                    }
                                    setValueEducation('lastDesignation', '');
                                    if (selectedValue !== '2' || '3') {
                                      clearErrors('lastDesignation');
                                    }
                                    setValueEducation('institutionWorkedLast', '');
                                    if (selectedValue !== '2' || '3') {
                                      clearErrors('institutionWorkedLast');
                                    }
                                  }}
                                  renderValue={(selected) => {
                                    const selectedOption = CurrentlyTeaching.find((option) => option.id === selected);
                                    return selectedOption ? selectedOption.name : 'Select Currently Teaching';
                                  }}
                                >
                                  {CurrentlyTeaching.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                      <FormControlLabel
                                        value={option.id}
                                        control={<Radio checked={field.value === option.id} />}
                                        label={option.name}
                                      />
                                    </MenuItem>
                                  ))}
                                </Select>
                                {errorsEducation.teaching && (
                                  <FormHelperText error>{errorsEducation.teaching.message}</FormHelperText>
                                )}
                              </FormControl>
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={<Typography className="text-dark">Your Current Designation</Typography>}
                          {...registerEducation("currentDesignation", {
                            required: isTeaching === 1 ? "Current Designation is required" : false,
                          })}
                          placeholder="Your Current Designation"
                          disabled={isTeaching !== 1}
                          error={!!errorsEducation.currentDesignation}
                          helperText={errorsEducation.currentDesignation?.message}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={<Typography className="text-dark">Name of Your Institution</Typography>}
                          {...registerEducation("institution", {
                            required: isTeaching === 1 ? "Institution is required" : false,
                          })}
                          placeholder="Name Of Your Institution"
                          disabled={isTeaching !== 1}
                          error={!!errorsEducation.institution}
                          helperText={errorsEducation.institution?.message}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={<Typography className="text-dark">Your Last Designation</Typography>}
                          {...registerEducation("lastDesignation", {
                            required: isTeaching === 3 ? "Last Designation is required" : false,
                          })}
                          placeholder="Your Last Designation"
                          disabled={isTeaching !== 3}
                          error={!!errorsEducation.lastDesignation}
                          helperText={errorsEducation.lastDesignation?.message}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={<Typography className="text-dark">Name of the Institution where you worked last</Typography>}
                          {...registerEducation("institutionWorkedLast", {
                            required: isTeaching === 3 ? "Institution where you worked last is required" : false,
                          })}
                          placeholder="Institution Where You Worked Last"
                          disabled={isTeaching !== 3}
                          error={!!errorsEducation.institutionWorkedLast}
                          helperText={errorsEducation.institutionWorkedLast?.message}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="primarilyTeachingLevel"
                          rules={{
                            required: 'Please select the level at which you are primarily teaching/taught',
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <FormControl fullWidth error={!!fieldState.error}>
                                <InputLabel>
                                  <Typography className="text-dark overflow-hidden text-nowrap">Level at which you are primarily teaching/taught</Typography>
                                </InputLabel>
                                <Select
                                  label={
                                    <Typography className="text-dark overflow-hidden text-nowrap">
                                      Level at which you are primarily teaching/taught
                                    </Typography>
                                  }
                                  value={field.value}
                                  onChange={(event, values) => {
                                    const selectedValue = event.target.value;
                                    field.onChange(selectedValue);
                                    const isOther = selectedValue === PrimarilyTeachingForTeacher.find(option => option.label === 'Other').id;
                                    setShowPrimarilyOtherInput(isOther);
                                    // If 'Other' is selected, clear the 'otherPrimarily' value
                                    if (isOther) {
                                      setOtherPrimarily('');
                                    }
                                  }}
                                  renderValue={(selected) => {
                                    const selectedOption = PrimarilyTeachingForTeacher.find((option) => option.id === selected);
                                    return selectedOption ? selectedOption.label : 'Select Primarily Teaching/Taught';
                                  }}
                                >
                                  {PrimarilyTeachingForTeacher.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                      <FormControlLabel
                                        value={option.id}
                                        control={<Radio checked={field.value === option.id} />}
                                        label={option.label}
                                      />
                                    </MenuItem>
                                  ))}
                                </Select>
                                {fieldState?.error && !showPrimarilyOtherInput && (
                                  <FormHelperText error>
                                    {fieldState.error.message}
                                  </FormHelperText>
                                )}
                              </FormControl>

                              {/* Conditionally render input for "Other" option */}
                              {showPrimarilyOtherInput && (
                                <Controller
                                  name="otherprimarilyTeachingLevel"
                                  control={controlEducation}
                                  rules={{
                                    required: showPrimarilyOtherInput ? 'Please specify the other level of teaching' : false,
                                  }}
                                  render={({ field: otherField, fieldState: otherFieldState }) => (
                                    <>
                                      <TextField
                                        fullWidth
                                        label={<Typography className="text-dark">Please specify</Typography>}
                                        placeholder="Specify other primarily teaching"
                                        variant="outlined"
                                        margin="normal"
                                        value={otherPrimarily}
                                        onChange={(e) => {
                                          otherField.onChange(e.target.value);
                                          setOtherPrimarily(e.target.value);
                                        }}
                                        error={!!otherFieldState.error}
                                        helperText={otherFieldState.error?.message}
                                      />
                                    </>
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlEducation}
                          name="natureWork"
                          rules={{ required: "Please select your nature of work" }}
                          render={({ field, fieldState }) => (
                            <>
                              <FormControl fullWidth error={!!fieldState?.error}>
                                <InputLabel>
                                  <Typography className="text-dark">Nature of your work:{" "}<span style={{ color: "red" }}>*</span></Typography>
                                </InputLabel>
                                <Select
                                  label={
                                    <Typography className="text-dark">
                                      Nature of Work
                                      <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                  }
                                  value={field.value || ""}
                                  onChange={(event) => {
                                    const selectedValue = event.target.value;
                                    field.onChange(selectedValue);
                                  }}
                                  renderValue={(selected) => {
                                    const selectedOption = (getStudentDetails?.type === 4 || getStudentDetails?.type === '4') ? TypeOfInstitution.find((option) => option.id === selected).type : NatureOfWork.find((option) => option.id === selected).name;
                                    return selectedOption ? selectedOption : 'Select Nature Of Work';
                                  }}
                                >
                                  {(getStudentDetails?.type === 4 || getStudentDetails?.type === '4') ?
                                    TypeOfInstitution.map((option) => (
                                      <MenuItem key={option.id} value={option.id}>
                                        {option.type}
                                      </MenuItem>
                                    )) :
                                    NatureOfWork.map((option) => (
                                      <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                      </MenuItem>
                                    ))
                                  }
                                </Select>
                                {fieldState?.error && (
                                  <FormHelperText error>
                                    {fieldState.error.message}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth margin="normal" className="mt-0">
                          <FormLabel component="legend" className="text-dark">
                            Are you a Ph.D. Research Supervisor?
                          </FormLabel>
                          <Controller
                            name="phdResearchSupervisor"
                            control={controlEducation}
                            defaultValue="0"
                            render={({ field }) => (
                              <RadioGroup
                                {...field}
                                row
                                value={field.value || "0"} // Ensure the value is bound to form state
                                onChange={(e) => field.onChange(e.target.value)} // Update form state on change
                              >
                                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                                <FormControlLabel value="0" control={<Radio />} label="No" />
                              </RadioGroup>
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={
                            <Typography className="text-dark overflow-hidden text-nowrap">
                              Name of the university where you are a research supervisor
                            </Typography>
                          }
                          {...registerEducation("nameResearchSupervisor")}
                          placeholder="University where you supervise research"
                          disabled={isPhd.toString() !== "1"}
                        />
                      </Grid>


                    </Grid>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button type="submit" variant="contained" className="menus-color">
                        Update
                      </Button>
                    </Box>
                  </form>
                </Box>
              )}
            </div>
          </>
        )}
      </>

      {/* Teacher Professional Development */}
      <>
        {key === "professionalDev" &&
          <>
            <Box>
              <div className="pt-1 pb-3">
                <div className="p-0">
                  <div className="Architects-header d-flex align-items-center justify-content-center">
                    <h2 className="title-font text-center">Professional Development</h2>
                  </div>
                </div>
              </div>
            </Box>
            <div className="p-md-5 p-3 overallPadding">

              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <Box className="container-fluid" sx={{ width: "100%", marginTop: "0px", marginBottom: "50px" }}>
                  <form className="mt-2" onSubmit={handleSubmitProfession((data) => UpdateTeachersMemberProfession(data, id))}>
                    <Grid container rowSpacing={3} columnSpacing={2}>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-dark">
                            Are you a member of any other Teachers’ Association?
                          </FormLabel>
                          <Controller
                            name="teacherAssociation"
                            control={controlProfession}
                            defaultValue="0"
                            render={({ field: { onChange, value } }) => (
                              <RadioGroup row value={value} onChange={onChange}>
                                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                                <FormControlLabel value="0" control={<Radio />} label="No" />
                              </RadioGroup>
                            )}
                          />
                        </FormControl>

                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          label={
                            <Typography className="text-dark">
                              If yes, mention the name of those associations
                            </Typography>
                          }
                          {...registerProfession("associationName")}
                          placeholder="Mention The Name Of Those Associations"
                          disabled={isTeachersAsso !== "1"}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlProfession}
                          name="professionalDevelopment"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                limitTags={1}
                                id="professionalDevelopment"
                                fullWidth
                                options={ProfessionalDevelopment}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  setShowProfessionOtherInput(selectedValues.some((value) => value?.name === 'Other'));
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  field.value ?
                                    ProfessionalDevelopment.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                    {option.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={!!fieldState?.error}
                                    helperText={fieldState?.error?.message}
                                    label={
                                      <Typography className="text-dark overflow-hidden text-nowrap" style={{ textOverflow: "ellipsis" }}>
                                        Which of the following would you like to do for your continuous professional development?
                                      </Typography>
                                    }
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showProfessionOtherInput && (
                                <Controller
                                  name="otherProfession"
                                  control={controlProfession}
                                  rules={{
                                    required: 'Please specify your other professional studies',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other professional studies"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherProfessionChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <h2 className="menus-green-color">Your Areas of Expertise:</h2>
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlProfession}
                          name="expertiseLiteraryStudies"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                limitTags={1}
                                id="expertiseLiteraryStudies"
                                fullWidth
                                options={LiteraryStudies}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  setShowLiteraryOtherInput(selectedValues.some((value) => value?.name === 'Other'));
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  field.value ?
                                    LiteraryStudies.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                    {option.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={<Typography className="text-dark">Literary Studies</Typography>}
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showLiteraryOtherInput && (
                                <Controller
                                  name="otherLit"
                                  control={controlProfession}
                                  rules={{
                                    required: 'Please specify your other literary studies',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other literary studies"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherLitChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlProfession}
                          name="expertiseLinguistics"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                id="expertiseLinguistics"
                                fullWidth
                                limitTags={1}
                                options={Linguistics}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  const otherSelected = selectedValues.some((value) => value?.name === 'Other');
                                  setShowLinguisticsOtherInput(otherSelected);
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  field.value ?
                                    Linguistics.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                    {option.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={<Typography className="text-dark">Linguistics</Typography>}
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showLinguisticsOtherInput && (
                                <Controller
                                  name="otherLing"
                                  control={controlProfession}
                                  rules={{
                                    required: 'Please specify your other linguistics studies',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other linguistics studies"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherLingChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlProfession}
                          name="expertiseELT"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                id="expertiseELT"
                                fullWidth
                                limitTags={1}
                                options={EnglishLanguageTeaching}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  const otherSelected = selectedValues.some((value) => value?.name === 'Other');
                                  setShowELTOtherInput(otherSelected);
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  field.value ?
                                    EnglishLanguageTeaching.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    {/* <Checkbox
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      /> */}
                                    {option.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={!!fieldState?.error}
                                    helperText={fieldState?.error?.message}
                                    label={
                                      <Typography className="text-dark">
                                        English Language Teaching (ELT)
                                      </Typography>
                                    }
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showELTOtherInput && (
                                <Controller
                                  name="otherELT"
                                  control={controlProfession}
                                  rules={{
                                    required: 'Please specify your other ELT studies',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other ELT studies"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherELTChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <Controller
                          control={controlProfession}
                          name="expertiseInterdisciplinaryAreas"
                          render={({ field, fieldState }) => (
                            <>
                              <Autocomplete
                                multiple
                                id="expertiseInterdisciplinaryAreas"
                                fullWidth
                                limitTags={1}
                                options={InterdisciplinaryAreas}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoIds = selectedValues.map((value) => value?.name);
                                  const otherSelected = selectedValues.some((value) => value?.name === 'Other');
                                  setShowInterOtherInput(otherSelected);
                                  field.onChange(contactInfoIds);
                                }}
                                value={
                                  field.value ?
                                    InterdisciplinaryAreas.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    {/* <Checkbox
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      /> */}
                                    {option.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={!!fieldState?.error}
                                    helperText={fieldState?.error?.message}
                                    label={
                                      <Typography className="text-dark">
                                        Interdisciplinary Areas
                                      </Typography>
                                    }
                                  />
                                )}
                              />

                              {/* Conditionally render input for "Other" option */}
                              {showInterOtherInput && (
                                <Controller
                                  name="otherInter"
                                  control={controlProfession}
                                  rules={{
                                    required: 'Please specify your other interdisciplinary areas',
                                  }}
                                  render={({ field, fieldState }) => (
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other interdisciplinary areas"
                                      variant="outlined"
                                      margin="normal"
                                      {...field}
                                      error={!!fieldState.error} // Show error if fieldState has an error
                                      helperText={fieldState.error?.message} // Display the error message
                                      onChange={(e) => {
                                        field.onChange(e.target.value); // Update field value
                                        handleOtherInterChange(e); // Update state for external handling (if needed)
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <h2 className="menus-green-color">Areas of Expertise:</h2>
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-dark">
                            Are you
                            willing to have your areas of
                            expertise or interest listed publicly
                            so that other members can identify
                            potential collaboration
                            opportunities?
                          </FormLabel>
                          <Controller
                            name="areaOfExpertise"
                            control={controlProfession}
                            defaultValue=""
                            render={({ field }) => (
                              <RadioGroup row {...field}>
                                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                                <FormControlLabel value="0" control={<Radio />} label="No" />
                              </RadioGroup>
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-dark">
                            Are you interested in being contacted
                            for the following activities?
                          </FormLabel>
                          <Controller
                            control={controlProfession}
                            name="professionalEngagement"
                            render={({ field, fieldState }) => (
                              <>
                                <Autocomplete
                                  multiple
                                  id="professionalEngagement"
                                  fullWidth
                                  limitTags={1}
                                  options={ProfessionalEngagement}
                                  disableCloseOnSelect
                                  getOptionLabel={(option) => option?.label}
                                  filterSelectedOptions
                                  onChange={(event, values) => {
                                    const selectedValues = Array.isArray(values) ? values : [];
                                    const contactInfoIds = selectedValues.map((value) => value?.label);
                                    field.onChange(contactInfoIds);
                                  }}
                                  value={
                                    field.value ?
                                      ProfessionalEngagement.filter((info) => field.value.includes(info.label)) : []
                                  }
                                  renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                      {/* <Checkbox
                                          style={{ marginRight: 8 }}
                                          checked={selected}
                                        /> */}
                                      {option.label}
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      error={!!fieldState?.error}
                                      helperText={fieldState?.error?.message}
                                      label={
                                        <Typography className="text-dark">
                                          Professional Engagement
                                        </Typography>
                                      }
                                    />
                                  )}
                                />
                              </>
                            )}
                          />
                        </FormControl>
                      </Grid>

                    </Grid>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button type="submit" variant="contained" className="menus-color">
                        Update
                      </Button>
                    </Box>
                  </form>
                </Box>
              )}
            </div>
          </>
        }
      </>
    </>
  );
}

export default TeachersProfile;